export enum CalendarType {
    WEEK,
    MONTH,
    YEAR
}